































import Button from '../../core/components/Button.vue';
import InputFile from '../../core/components/InputFile.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
  downloadArrayBuffer,
    EventBus,
    formatDate,
    goToUrl,
    TypeEventBus,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import { SuscriptionsList, Template, UsersEmails, Suscription, Vehicle, AvailableVehiclesList, RadioOptions, RadioOption, DownloadReportsExcel, dateTypes, UserCompaniesReports, diffOptions } from '../../core/models';
import { ReportsServices } from '../api/ReportsServices';

@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle,
        InputFile,
        DeleteConfirmation
    }
})
export default class PreviousExcelsList extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default: '' }) templateId: string;
    @Prop({ default: null }) companySelected: object | null;
    modalTitle: string = "Excels anteriores: ";
    isGettingExcels: boolean = false;
    excelsList: Array<object> = [];
    headers: Array<object> = [
        {
            text: 'Nombre',
            value: 'name',
            align: 'left',
        },
        {
            text: 'Fecha subido',
            value: 'date',
            align: 'center',
            formatter: (value) => formatDate(value, false)
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'left',
            sortable: false,
            width: '80px'
        }
    ]
    sortDesc: boolean[] = [true];
    sortBy: string[] = ['date'];
    deleteConfirmationBody: string = '';
    confirmationDelete: boolean = false;
    summaryDeleteConfirmation: string[] = [];
    excelIdToDelete: number = -1;
    deleteFileTitle: string = '';

    @Watch('companySelected')
    onCompanyChanged() {
        this.getExcelsList();
    }

    showDeleteConfirmation(item) {
        this.deleteFileTitle = 'Eliminar Excel';
        this.excelIdToDelete = item['id'];
        this.confirmationDelete = true;
        this.summaryDeleteConfirmation = [];
        this.deleteConfirmationBody = `¿Desea borrar el archivo <b>${item['name']}</b>?`;
    }

    deleteExcel(userConfirmation: boolean) {
        let excelId = this.excelIdToDelete;
        if(userConfirmation){
            this.isGettingExcels = true;
            ReportsServices.deleteExcelForReport(
                excelId
            ).then(response => {
                this.$_successLoadingDialog({
                    response: response || {},
                    alternative_msg: ''
                })
                this.getExcelsList();
            }).catch(error => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo borrar el excel'
                });
            }).finally(() => {
                this.isGettingExcels = false;
            })
        }

        this.confirmationDelete = false;
        this.excelIdToDelete = -1;
        this.summaryDeleteConfirmation = [];
    }


    downloadExcel(item) {
        let fileId = item['id'];
        let fileName = item['name'];
        this.isGettingExcels = true;
        ReportsServices.downloadExcelForReport(
            fileId
        ).then(file => {
            downloadArrayBuffer(fileName, file, '');
        }).catch(error => {
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'Falló la descarga de Excel'
            });
        }).finally(() => {
            this.isGettingExcels = false;
        })
    }

    getExcelsList() {
        if(!this.companySelected){
            return
        }
        let companyId = this.companySelected['id'];
        this.isGettingExcels = true;
        ReportsServices.getExcelsList(this.templateId, companyId)
            .then(response => {
                this.excelsList = response.data;
                
            }).catch(error => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo cargar la lista de excels'
                })
            }).finally(() => {
                this.isGettingExcels = false;
            })
    }

    mounted() {
        this.$nextTick(() => {
            this.getExcelsList();
        })
    }
    
}
